import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = '¡SÍ, QUIERO MI MEGA PACK!',
  subtext,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (href) {
      return;
    }
    e.preventDefault();
    if (onClick) {
      onClick();
    }
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const ButtonContent = () => <motion.div whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    scale: [1, 1.02, 1],
    boxShadow: ['0px 4px 0px #C2410C', '0px 6px 0px #C2410C', '0px 4px 0px #C2410C']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`bg-gradient-to-b from-orange-400 to-orange-500 hover:from-orange-300 hover:to-orange-400 text-white font-black text-xl md:text-2xl py-4 px-8 md:py-5 md:px-12 rounded-full shadow-xl border-b-[6px] border-orange-700 w-full md:w-auto max-w-3xl flex flex-col items-center justify-center gap-1 uppercase tracking-wide cursor-pointer relative overflow-hidden ${className}`} data-id="element-65">
      <div className="absolute top-0 left-0 w-full h-full bg-white opacity-10 rounded-full transform -skew-x-12 translate-x-full animate-[shimmer_2s_infinite]" data-id="element-66"></div>

      <span className="flex items-center gap-3 text-center leading-tight z-10 drop-shadow-md" data-id="element-67">
        {text}{' '}
        <ArrowRight className="w-6 h-6 md:w-8 md:h-8 hidden md:inline" strokeWidth={3} data-id="element-68" />
      </span>
      {subtext && <span className="text-xs md:text-sm font-bold normal-case opacity-90 z-10 bg-orange-700/30 px-3 py-0.5 rounded-full mt-1" data-id="element-69">
          {subtext}
        </span>}
    </motion.div>;
  if (href) {
    return <div className="flex flex-col items-center justify-center w-full p-2" data-id="element-70">
        <a href={href} className="no-underline w-full md:w-auto flex justify-center" data-id="element-71">
          <ButtonContent data-id="element-72" />
        </a>
      </div>;
  }
  return <div className="flex flex-col items-center justify-center w-full p-2" data-id="element-73">
      <button onClick={handleClick} className="w-full md:w-auto flex justify-center bg-transparent border-none p-0" data-id="element-74">
        <ButtonContent data-id="element-75" />
      </button>
    </div>;
}